export default '2.3.3';



// WEBPACK FOOTER //
// ./src/lib/version.js